import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_ALIGN,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_HEADING_LEVEL,
} from '@gcloud-npm/next12.components.text-info';
import { SendSondaComponentNotShown } from '@/utils/functions';
import { useDispatch } from 'react-redux';
import styles from './styles';

const ModuloTitle = (props) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!props) {
      const componentName = 'ModuloTitle';
      SendSondaComponentNotShown(componentName, dispatch);
      return null;
    }
  }, []);

  const { title, textAlign, fontType, kind, color, size } = props;
  return (
    <>
      <div className="moduloTitle container">
        <TextInfo
          text={title}
          kind={kind || TEXT_INFO_KIND.HEADING}
          level={TEXT_INFO_HEADING_LEVEL.H2}
          align={textAlign || TEXT_INFO_ALIGN.CENTER}
          color={color || TEXT_INFO_COLOR.GREY_6}
          size={size || TEXT_INFO_SIZE.TITLE2}
          fontType={fontType || TEXT_INFO_FONT_WEIGHT.BOLD}
          className="title"
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ModuloTitle;

ModuloTitle.propTypes = {
  title: PropTypes.string,
};
ModuloTitle.defaultProps = {
  title: '',
};
